import { useEffect, useContext, createContext, useState } from "react";
import { getCartCollaboration } from "../api/collaborationApi";
import { UserContext } from "./userContext";


export const FiltersContext = createContext();

export default function FiltersProvider({ children }) {

    const [featuredFilter, setFeaturedFilter] = useState(false);
    const [newUserFilter, setNewUserFilter] = useState(false);
    const [languageFilter, setLanguageFilter] = useState([]);
    const [ratingFilter, setRatingFilter] = useState(null);
    const [verifiedFilter, setVerifiedFilter] = useState([]);
    const [genderFilter, setGenderFilter] = useState([]);
    const [ageFilter, setAgeFilter] = useState([]);
    const [networkFilter, setNetworkFilter] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState([]);
    const [countryFilter, setCountryFilter] = useState([]);
    const [priceFilter, setPriceFilter] = useState([]);
    const [queryPrice, setQueryPrice] = useState([]);
    const [queryPriceId, setQueryPriceId] = useState([]);
    const [inputFilter, setInputFilter] = useState('');

    const [orderBy, setOrderBy] = useState('');

    //const [offset, setOffset] = useState(0);


    return (
        <FiltersContext.Provider value={{ featuredFilter, setFeaturedFilter, newUserFilter, setNewUserFilter, languageFilter, setLanguageFilter, ratingFilter, setRatingFilter, verifiedFilter, setVerifiedFilter, genderFilter, setGenderFilter, ageFilter, setAgeFilter, networkFilter, setNetworkFilter, categoryFilter, setCategoryFilter, countryFilter, setCountryFilter, priceFilter, queryPrice, setQueryPrice, queryPriceId, setQueryPriceId, setPriceFilter, inputFilter, setInputFilter, orderBy, setOrderBy/* , offset, setOffset */ }}>
            {children}
        </FiltersContext.Provider >
    )

};